import React from 'react';

import type { SVGProps } from '@atlaskit/icon/svg';
import SVG from '@atlaskit/icon/svg';

export const HomeIcon = (props: SVGProps) => (
	<SVG {...props}>
		<rect width="24" height="24" fill="none" fillOpacity="0.01" />
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.8375 3.60105C11.5329 3.10434 12.4671 3.10434 13.1625 3.60105L19.1625 7.88676C19.6881 8.26219 20 8.86833 20 9.51423V17.9996C20 19.1042 19.1046 19.9996 18 19.9996H15C13.8954 19.9996 13 19.1042 13 17.9996V14.4996H11V17.9996C11 19.1042 10.1046 19.9996 9 19.9996H6C4.89543 19.9996 4 19.1042 4 17.9996V9.51423C4 8.86833 4.31193 8.26219 4.83752 7.88676L10.8375 3.60105ZM18 9.51423L12 5.22852L6 9.51423V17.9996H9V14.4996C9 13.395 9.89543 12.4996 11 12.4996H13C14.1046 12.4996 15 13.395 15 14.4996V17.9996H18V9.51423Z"
			fill="currentColor"
		/>
	</SVG>
);
